module.exports = __webpack_public_path__ + "static/media/about.b32dda23.svg";